import React from 'react';
import { Table } from 'semantic-ui-react';

export default function DateTableHeaderCell(): React.ReactElement {
    return (
        <Table.HeaderCell className="table-header-cell date">
            <div className="table-header-cell-inner">
                <span className="title">Select type</span>
                <span className="subtitle">Apply to all</span>
            </div>
        </Table.HeaderCell>
    );
}
